<template>
    <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="table-body">
            <data-analysis-query-list-component ref="DataAnalysisQueryListComponent" @afterLoadData="onAfterLoadData"></data-analysis-query-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DataAnalysisQueryListComponent from "../components/DataAnalysisQueryListComponent.vue";
export default {
    components: { SaPageLayout, DataAnalysisQueryListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            linkedit: "/dataanalysisquery",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.DataAnalysisQueryListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
    },
};
</script>

<style></style>
